import type { CardPair } from './types';

const DECKS_KEY = 'farmerGameDecks';
const API_KEY_KEY = 'farmerGameApiKey';

export function loadDecks(): Record<string, CardPair[]> {
  try {
    const raw = localStorage.getItem(DECKS_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed !== 'object' || parsed === null) return {};
    return parsed as Record<string, CardPair[]>;
  } catch {
    return {};
  }
}

export function saveDecks(decks: Record<string, CardPair[]>): void {
  try {
    localStorage.setItem(DECKS_KEY, JSON.stringify(decks));
  } catch {
    /* localStorage 滿或被禁用，靜默忽略 */
  }
}

export function loadApiKey(): string {
  try {
    return localStorage.getItem(API_KEY_KEY) ?? '';
  } catch {
    return '';
  }
}

export function saveApiKey(key: string): void {
  try {
    localStorage.setItem(API_KEY_KEY, key);
  } catch {
    /* noop */
  }
}

export function clearApiKey(): void {
  try {
    localStorage.removeItem(API_KEY_KEY);
  } catch {
    /* noop */
  }
}
